import React from 'react';
import './Circles.scss';

type Props = {
  size: string,
  color: string,
  text?: string
};

const Circles = ({ size, color, text }: Props) => {
  const numsForCircles = Array.from(new Array(12).keys());
  const circles = numsForCircles.map(key => (
    <div key={`circle${key + 1}`} className={`sk-circle${key + 1} sk-circle`} />
  ));

  // color와 size props는 필수입니다.
  // color는 gray, blue 중 선택할 수 있습니다.
  // size는 medium, small 중에서 선택가능합니다.
  // 함께 사용하고 싶은 텍스트가 있을 경우, text props로 추가하면 됩니다.
  return text ? (
    <div className="loaderWithText">
      <div className={`sk-fading-circle ${size} ${color}`}>{circles}</div>
    </div>
  ) : (
    <div className={`sk-fading-circle ${size} ${color}`}>{circles}</div>
  );
};

export default Circles;



// WEBPACK FOOTER //
// ./src/components/common/Loaders/Circles.js